$(document).on('click', '#buy-now-global', function () {
    var apiUrl = $(this).data('url');
    var productId =  $('a.size-selector-box.active').attr('data-product-id');
    if(!productId){
        $('.size-not-selected-error').removeClass('d-none');
        return false;
    }
     $.spinner().start();
   $.ajax({
        url: apiUrl,
        type: 'GET',
        data: { pid: productId },
        success: function (response) {
            $.spinner().stop();
            if (response.success) {
                response.eventDataForGA.currentPage = window.location.href;
               // Add to cart event
                response.eventDataForGA.event = 'add_to_cart';
                response.eventDataForGA.eventCategory = 'addToCart';
                dataLayer.push(response.eventDataForGA);

                // Buy Now event
                response.eventDataForGA.event = 'buy_now';
                response.eventDataForGA.eventCategory ='buyNow';
                dataLayer.push(response.eventDataForGA);

                // Checkout begin event
                response.eventDataForGA.event = 'begin_checkout';
                response.eventDataForGA.eventCategory = 'Checkout';
                response.eventDataForGA.eventAction = 'Begin Checkout';
                dataLayer.push(response.eventDataForGA);
                window.location.href = response.redirectUrl;
            } else {
                $('.size-not-selected-error').html('<i class="fa fa-exclamation-circle" aria-hidden="true"></i> Something Went Wrong!');
                $('.size-not-selected-error').removeClass('d-none');
            }
        },
        error: function (xhr, status, error) {
            $.spinner().stop();
            $('.size-not-selected-error').html('<i class="fa fa-exclamation-circle" aria-hidden="true"></i> Something Went Wrong!');
            $('.size-not-selected-error').removeClass('d-none');
        }
    });
});


